import "./loading-icon.styles.css";

const LoadingIcon = () => {
  return <div className="loading-icon"></div>;
};

export default LoadingIcon;
